// import {WordClass} from '@Corrl/vocabeo-shared-types';
// import type {Num} from '$lib/classes/data/word';
//
export const prerender = true
export const ssr = true
//
// export async function load({parent}) {
//     const {
//         setup,
//         allWords,
//         sentenceManager,
//     } = await parent()
//
//     await setup
//
//     const numbers = allWords.filter(word => word.art === WordClass.Num).sort((listItem1, listItem2) => parseInt((listItem1 as Num).num) - parseInt((listItem2 as Num).num))
//
//     const wordListItems = numbers.map(word => {
//         return {
//             id: word.id,
//             word: (word as Num).num + '  ' + (word.base.displayWord || word.word), //TODO remove number when word
//             english: word.base.translations.join(', '),
//             sentence: sentenceManager.getFirstSentence(word.id)?.sentence,
//             t: sentenceManager.getFirstSentence(word.id)?.t,
//         }
//     })
//
//     // NOTE simply copy from log in console in browser via context menu
//     console.log('wordListItems', wordListItems)
//
//     return {}
// }